export enum BalanceActionsEnum {
	GET_BALANCE = '[Balance Api] Get Balance ',
	RESET_BALANCE = '[Balance] Reset Balance ',
	CHECK_BALANCE = '[Balance] Select Plan',
	RECALCULATE_BALANCE = '[Balance] Calculate Next Balance',
	SET_BALANCE_FOR_PAYMENT = '[Balance] Set Next Balance',
	CHANGE_BALANCE_CURRENCY = '[Balance] Change Balance Currency',
}
